import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import Pagination from '../../components/tables/pagination/Pagination';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Table from '../../components/tables/Table';
import loaderImage from "../../assets/icons/part-logo.png";
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import Card from '../../components/cards/Card';
import { toast } from 'react-toastify';
import { formatDateTime } from '../../utils/FormatDateTime';
import { getUserName } from '../../utils/localStoarege';
import { getCenterAllotMedicines, getCenterMedicinesHistory } from '../../services/clinic/centers';


function AccountIssuedMedicineInvoice() {
    const [cardData, setCardData] = useState([
        // {
        //     title: "Total Medicines Issued",
        //     count: "--",
        // },
        // {
        //     title: "Total Medicines Sold",
        //     count: "--",
        // },
    ]);

    const [tableData, setTableData] = useState({});
    const [tableData2, setTableData2] = useState({});
    const [dropdownData, setDropdownData] = useState(getUserName() === "null" ? null : getUserName());
    const headers = [
        { label: "Alloted Date", key: "created_at" },
        // { label: "Center", key: "center_name" },
        { label: "Medicine", key: "medicine_name" },
        { label: "Quantity", key: "quantity" },
    ];
    const headers2 = [
        { label: "Alloted Date", key: "created_at" },
        { label: "Medicine", key: "medicine_name" },
        { label: "Stock Quantity", key: "quantity" },
    ];

    const [currentPage, setCurrentPage] = useState(1);
    const [currentPage2, setCurrentPage2] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);

    const pageSize = 100;


    const fetchData = async () => {
        setLoading(true);
        try {
            let res = await getCenterAllotMedicines(getUserName());
            if (res.status === 200) {
                setTableData(res.data);
            } else {
                toast.error("Unable to fetch medicines");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Medicines:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchData2 = async () => {
        setLoading2(true);
        try {
            let res = await getCenterMedicinesHistory(getUserName());
            if (res.status === 200) {
                setTableData2(res.data);
            } else {
                toast.error("Unable to fetch medicines History");
            }
            setLoading2(false);
        } catch (error) {
            console.error("Error fetching Medicine History:", error);
        } finally {
            setLoading2(false);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePageChange2 = (page) => {
        setCurrentPage2(page);
    };

    useEffect(() => {
        if (getUserName() !== "null") {
            fetchData();
            fetchData2();
        }
    }, []);

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/invoice' },
            { name: 'Issued Medicines' },
        ]} />
        <div className="py-3">
            <div className="flex flex-row items-center gap-4">
                <StyledHeadingText text={"Issued Medicines"} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">
                {cardData.map((card, index) => (
                    <Card title={card.title} count={card.count} />
                ))}
            </div>
        </div>
        {
            dropdownData ?
                <>
                    {
                        <div className="mt-2 flex flex-col xl:flex-row gap-3">
                            <div className="w-full flex-1">
                                {loading ?
                                    <div className="flex w-full flex-row justify-center my-2">
                                        <CustomLoading imageSrc={loaderImage} size={100} />
                                    </div>
                                    :
                                    <Table
                                        headers={headers}
                                        rows={tableData?.results?.map((item, index) => (
                                            {
                                                center_name: <p>{item.center_name}</p>,
                                                created_at: <p>{formatDateTime(item.created_at)}</p>,
                                                medicine_name: <p>{item.medicine_name}</p>,
                                                quantity: <p>{item.quantity_alloted}</p>,
                                            }))}
                                    />}
                                {tableData.count !== 0 ?
                                    <div className="xl:pl-5 pl-0 w-full flex-1">
                                        <Pagination
                                            currentPage={currentPage}
                                            totalPages={Math.ceil(tableData?.count / pageSize)}
                                            pageSize={pageSize}
                                            totalEntries={tableData?.count}
                                            onPageChange={handlePageChange}
                                            data={tableData}
                                            setTableData={setTableData}
                                        />
                                    </div> : <></>}
                            </div>
                            <div className="w-full flex-1">
                                {loading2 ?
                                    <div className="flex w-full flex-row justify-center my-2">
                                        <CustomLoading imageSrc={loaderImage} size={100} />
                                    </div>
                                    :
                                    <Table
                                        headers={headers2}
                                        rows={tableData2?.results?.map((item, index) => (
                                            {
                                                created_at: <p>{formatDateTime(item.created_at)}</p>,
                                                medicine_name: <p>{item.medicine_name}</p>,
                                                quantity: <p>{item.stock_qt}</p>,
                                            }))}
                                    />}
                                {tableData2.count !== 0 ?
                                    <div className="xl:pl-5 pl-0 w-full flex-1">
                                        <Pagination
                                            currentPage={currentPage2}
                                            totalPages={Math.ceil(tableData2?.count / pageSize)}
                                            pageSize={pageSize}
                                            totalEntries={tableData2?.count}
                                            onPageChange={handlePageChange2}
                                            data={tableData2}
                                            setTableData={setTableData2}
                                        />
                                    </div> : <></>}
                            </div>
                        </div>
                    }
                </> :
                <div className="flex flex-row py-10 w-full items-center justify-center bg-white rounded-md shadow-lg mx-2 mt-10 border-primary">
                    <StyledHeadingText text={"Select center to view data"} />
                </div>

        }
    </>);
}

export default AccountIssuedMedicineInvoice;